const bulkIdPattern = /^\d+x\d+$/i;

// eslint-disable-next-line import/prefer-default-export
export function doesUsernameMatchBulkId(username) {
  return typeof username === 'string' && bulkIdPattern.test(username);
}
